import React from 'react';
import { Text, View } from 'react-native';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { faGift } from '@fortawesome/pro-regular-svg-icons';
import useCustomTheme from '../../../hooks/theme-hook';
import useTranslation from '../../../hooks/translation-hook';
import CustomButton from '../../common/CustomButton';

export default function ProfileBonusAwardCard({ rewardPoints, onViewRewards }: { rewardPoints: number; onViewRewards(): void }) {
  const t = useTranslation();
  const theme = useCustomTheme();
  const ink = theme.isDark ? '#DCF4ED' : '#035164';

  return <View testID="profile-bonus-award" accessibilityLiveRegion="polite"
    style={{ marginTop: 16, padding: 20, gap: 16, borderRadius: 12, backgroundColor: theme.background.missionDetail.toString() }}>
    <View style={{ flexDirection: 'row', alignItems: 'center', gap: 12 }}>
      <View accessibilityElementsHidden importantForAccessibility="no-hide-descendants"
        style={{ width: 48, height: 48, borderRadius: 24, alignItems: 'center', justifyContent: 'center', backgroundColor: theme.isDark ? '#4A4025' : '#FFF0CD' }}>
        <FontAwesomeIcon icon={faGift} size={24} color={theme.isDark ? '#FFC559' : '#7A5100'} />
      </View>
      <View style={{ flex: 1, minWidth: 0, gap: 4 }}>
        <Text accessibilityRole="header" style={{ color: ink, fontSize: 16, lineHeight: 22, fontWeight: '700' }}>{t('profile-bonus-success-title')}</Text>
        <Text style={{ color: ink, fontSize: 32, lineHeight: 40, fontWeight: '700' }}>{`+${t('points-value', { value: rewardPoints })}`}</Text>
      </View>
    </View>
    <Text style={{ color: ink, fontSize: 14, lineHeight: 20 }}>{t('profile-bonus-awarded')}</Text>
    <CustomButton accessibilityRole="button" title={t('profile-bonus-view-rewards')} onPress={onViewRewards}
      style={{ minHeight: 44, alignSelf: 'stretch' }} textStyle={{ color: 'white' }}
      contentStyle={{ flex: 0, height: 'auto', minHeight: 44 }} />
  </View>;
}
